import { Service, inject } from '@angular/core';

import { ApiService } from './api.service';
import { SnackBarService } from './snackbar.service';

import { CautareStore } from '../state/cautare.store';
import { RegistruCMJ } from '../models/cautare.model';
import { executa } from './executa';

@Service()
export class CautareService {
  private readonly cautareStore = inject(CautareStore);
  private apiService = inject(ApiService);
  private snackBar = inject(SnackBarService);

  cautaMedic(data: string, endpoint: string) {
    const value2 = data.replace(/\s/g, '');
    return executa(this.apiService.cautareMedic<RegistruCMJ>(value2, endpoint), response => {
        switch (endpoint) {
          case 'cmj':
            // this.cautareStore.clearListaCmj();
            this.cautareStore.setListaCmj(response);
            break;
          case 'cmr':
            // this.cautareStore.clearListaCmr();
            this.cautareStore.setListaCmr(response);
            break;
        }
    }, this.snackBar);
  }
}
